exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ccm-client-settings--_odXduMZSwO2glaTE4gjV {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  padding: 10px 10px 10px 0px;\n}\n\n.ccm-client-settings--2bEkp6XMY3aY9Y3OkD4YNK {\n  display: flex;\n  flex-direction: row;\n}\n\n.ccm-client-settings--2i1KyvgJRyDkl5TSWfGmRz {\n  min-width: 3rem;\n}\n\n.ccm-client-settings--31OUrG12742J7XHgJujGMz {\n  background: #373939;\n}\n", ""]);

// exports
exports.locals = {
	"modalContainer": "ccm-client-settings--_odXduMZSwO2glaTE4gjV",
	"modalContainer": "ccm-client-settings--_odXduMZSwO2glaTE4gjV",
	"buttonContainer": "ccm-client-settings--2bEkp6XMY3aY9Y3OkD4YNK",
	"buttonContainer": "ccm-client-settings--2bEkp6XMY3aY9Y3OkD4YNK",
	"actionBtn": "ccm-client-settings--2i1KyvgJRyDkl5TSWfGmRz",
	"actionBtn": "ccm-client-settings--2i1KyvgJRyDkl5TSWfGmRz",
	"cancelBtn": "ccm-client-settings--31OUrG12742J7XHgJujGMz",
	"cancelBtn": "ccm-client-settings--31OUrG12742J7XHgJujGMz"
};